<template>
  <b-card class="list-card-item" tag="li" no-body>
    <div class="vcard card">
      <div class="card-img-top">
        <img v-if="association.logoUrl" :src="association.logoUrl" class="mx-auto d-block" :alt="altLogo" />
        <div v-else class="default-picture">
          <i class="fa fa-image"></i>
        </div>
      </div>
      <b-card-title
        title-tag="span"
        class="title-level level-3 mx-2 card-title"
        role="heading"
        :aria-level="titleLevel"
        >{{ association.raisonSociale }}</b-card-title
      >
      <b-card-body>
        <b-card-text class="mx-2">
          <span v-if="association.activite">
            {{ i18n.activites.label }} :
            <b>{{ association.activite }}</b>
            <br />
          </span>
          <span v-if="association.public">
            {{ i18n.public.label }} :
            <b>{{ association.public }}</b>
            <br />
          </span>
          <span v-if="association.rue">
            {{ i18n.rue.label }} :
            <b>{{ association.rue }}</b>
            <br />
          </span>
          <span v-if="association.ville || association.codePostal">
            {{ i18n.city.label }} :
            <b>{{ association.codePostal }} {{ association.ville }}</b>
            <br />
          </span>
          <span v-if="association.quartier">
            {{ i18n.quartier.label }} :
            <b>{{ association.quartier }}</b>
            <br />
          </span>
          <span v-if="association.contact">
            {{ i18n.name.label }} :
            <b>{{ association.contact }}</b>
            <br />
          </span>
          <span v-if="association.courriel">
            <i class="fa fa-envelope" aria-hidden="true"></i>
            <span class="sr-only">{{ i18n.mail.label }}</span>
            <a
              class="vignette-link"
              :href="`mailto:${association.courriel}`"
              :title="i18n.mail.placeholder"
              target="_blank"
              >{{ association.courriel }}</a
            >
            <br />
          </span>
          <span v-if="association.telephone">
            <i class="fa fa-phone" aria-hidden="true"></i>
            <span class="sr-only">{{ i18n.phone.label }}</span>
            <a class="vignette-link" :href="`tel:${association.telephone}`">{{ association.telephone }}</a>
            <br />
          </span>
          <span v-if="association.site">
            <i class="fa fa-globe" aria-hidden="true"></i>
            <span class="sr-only">{{ i18n.website.label }}</span>
            <a class="vignette-link" :href="linkToHttp" target="_blank" :title="i18n.website.placeholder"
              >{{ association.site }}&nbsp;<i class="fa fa-external-link fa-sm" aria-hidden="true"></i
            ></a>
          </span>
        </b-card-text>
      </b-card-body>
      <div class="justify-content-end d-flex card-footer">
        <span>
          {{ i18n.updated }} :
          <i>{{ formattedDate }}</i>
        </span>
      </div>
    </div>
  </b-card>
</template>

<script>
import { format, parseISO } from 'date-fns';
import { BCardBody, BCard, BCardText, BCardTitle } from 'bootstrap-vue';
import { titleLevelHelper } from '@/helpers/index.js';

export default {
  components: {
    BCard,
    BCardBody,
    BCardText,
    BCardTitle,
  },
  props: {
    association: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedDate() {
      return format(parseISO(this.association.date), 'dd/MM/yyyy');
    },
    /**
     * Compute alt logo value
     */
    altLogo() {
      return `${this.i18n.logo.label} : ${this.association.raisonSociale}`;
    },
    /**
     * Test if the website starts with http or https
     */
    linkToHttp() {
      const regex = /^(?!http(s){0,1}:\/\/)/i;
      return regex.test(this.association.site) ? `http://${this.association.site}` : this.association.site;
    },
  },
  data: function() {
    return {
      titleLevel: titleLevelHelper.computeTitleLevel(3),
      searchVisible: true,

      i18n: {
        updated: this.$t(`updated`),
        activites: {
          label: this.$t(`activites.label`),
        },
        website: {
          label: this.$t(`website.label`),
          placeholder: this.$t(`website.placeholder`),
        },
        phone: {
          label: this.$t(`phone.label`),
        },
        mail: {
          placeholder: this.$t(`mail.placeholder`),
          label: this.$t(`mail.label`),
        },
        address: {
          label: this.$t(`address.label`),
        },
        city: {
          label: this.$t(`city.label`),
        },
        logo: {
          label: this.$t(`logo.label`),
        },
        quartier: {
          label: this.$t(`quartier.label`),
        },
        rue: {
          label: this.$t(`rue.label`),
        },
        public: {
          label: this.$t(`public.label`),
        },
        name: {
          label: this.$t('name.label'),
        },
      },
    };
  },
};
</script>
